import {SET_OPERATOR, GET_OPERATORS, SET_POLICY_VERIFIED} from '../actions/driveright';

const initialState = {
    operator: {},
    operators: [],
    policyVerified: false
};

export const driverightReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_OPERATOR:
            return {...state, operator: action.operator};
        case GET_OPERATORS:
            return {...state, operators: action.operators};
        case SET_POLICY_VERIFIED:
            return {...state, policyVerified: action.verified};
        default:
            return {...state};
    }
};